import React from "react";
import { Stack } from "@mui/material";

import { HubButton, HubCircularProgress } from "../../components";

import { StyledBackgroundStack, StyledLabelStack } from "./styles";

export const DocuBuilderPreview = ({
  data = {},
  Template,
  isLoading = false,
  previewLabel = "This is a Preview",
  isPreview = true,
}) => {
  return (
    <StyledBackgroundStack>
      {isLoading ? (
        <HubCircularProgress centerScreen />
      ) : (
        <Stack>
          <StyledLabelStack>
            {Template && <Template {...data} />}
          </StyledLabelStack>
        </Stack>
      )}
      {isPreview && (
        <HubButton
          variant="contained"
          color="neutral"
          size="small"
          label={previewLabel}
          icon="Eye"
          iconProps={{ size: 12 }}
          sx={{ position: "absolute", bottom: "25px", left: "25px" }}
        />
      )}
    </StyledBackgroundStack>
  );
};

export default DocuBuilderPreview;
